import {useContext, useEffect, useMemo, useState} from "react";
import {Link, Outlet, useLocation} from "react-router-dom";
import {TsAdminContext} from "../context/ts-admin";
import {Col, Nav, Row} from "react-bootstrap";
import {Index} from "../components/org-info";
import {CONNECT_TYPE_EX, ENVIRONMENT_TYPE_PRODUCT, isHoshinoAccountMode, isKagomeAccountMode} from "../common";

export function LayoutUser(props) {
    const [menu, setMenu] = useState<any>();
    const [currentTab, setCurrentTab] = useState(useLocation().pathname);
    const [orgInfo, setOrgInfo, userInfo] = useContext(TsAdminContext);
    const [isEnableStorageTab, setIsEnableStorageTab] = useState<boolean>(false);

    const isHoshinoMode = useMemo(() => {
        return isHoshinoAccountMode(orgInfo?.currentAccount);
    }, [orgInfo]);

    const isKagomeMode = useMemo(() => {
        return isKagomeAccountMode(orgInfo?.currentAccount);
    }, [orgInfo]);

    useEffect(() => {
        setIsEnableStorageTab(orgInfo?.currentAccount.useAccessControl &&
            orgInfo?.currentOrg?.ConnectType !== CONNECT_TYPE_EX
        );
    }, [orgInfo])

    useEffect(() => {
        let currentMenu: any = [
            {
                id: 1,
                name: "TeamSpirit接続情報",
                path: ["/ts-connect", "/"],
            },
            {
                id: 2,
                name: "打刻連携アドオン（ICカード）",
                path: ["/pittouch-settings"],
            },

            {
                id: 4,
                name: "ICカード端末設定",
                path: ["/provider-settings"],
            },
            {
                id: 5,
                name: "QRコード打刻設定",
                path: ["/qr-settings"],
            },
            {
                id: 7,
                name: "ログ確認",
                path: ["/log-reports"],
            },
            // {
            //     id: 7,
            //     name: "打刻ログ（過去分）",
            //     path: ["/attendance-logs"],
            // },
            {
                id: 8,
                name: "打刻ログ",
                path: ["/attendance-logs-v2"],
            },
            {
                id: 11,
                name: "部署ジョブマッピング",
                path: ["/department-job-mapping"],
            },
            {
                id: 12,
                name: "データ送信マスタ",
                path: ["/health-condition-master"],
            },
        ];
        if (!isHoshinoMode) {
          currentMenu = currentMenu.filter(item => item.name !== '部署ジョブマッピング');
        }
        if (!isKagomeMode) {
          currentMenu = currentMenu.filter(item => item.name !== 'データ送信マスタ');
        }
        if (isEnableStorageTab) {
            currentMenu.push({
                id: 9,
                name: "入退館連携",
                path: ["/storage-configuration"],
            });
        }
        if (orgInfo?.currentAccount?.useAttendanceApplication) {
            currentMenu.push({
                id: 6,
                name: "QRコード打刻勤怠申請設定",
                path: ["/qr-settings-v2"],
            });
        }
        if (orgInfo && orgInfo?.currentOrg?.ConnectType == 2) {
            currentMenu.push({
                    id: 3,
                    name: "TeamSpirit EX設定",
                    path: ["/pittouch-ex"],
                },
                /*{
                    id: 6,
                    name: "QRコード打刻勤怠申請設定",
                    path: ["/qr-settings-application"],
                }*/
            );

        }
        const orderMenu = currentMenu.sort((a, b) => a.id - b.id);
        const operatorMenu = [
            {
                id: 10,
                name: "QRコード発行",
                path: ["/qr-code-export", "/"],
            }
        ]
        if (userInfo?.isSuperAdmin) {
            setMenu(orderMenu);
        } else {
            setMenu(userInfo?.PermissionsModifyAllData ? orderMenu : operatorMenu);
        }
    }, [orgInfo, isEnableStorageTab, isHoshinoMode, isKagomeMode])

    const getClassEnv = () => {
        if (localStorage.getItem('environment-type')) {
            const envType = localStorage.getItem('environment-type') || ENVIRONMENT_TYPE_PRODUCT;
            return envType == ENVIRONMENT_TYPE_PRODUCT ? '' : 'env-sandbox-body'
        } else {
            if (orgInfo) {
                return orgInfo?.currentOrg?.EnvironmentType == ENVIRONMENT_TYPE_PRODUCT ? '' : 'env-sandbox-body'
            }
        }

    }
    return (
        <div>
            <Row className={`${getClassEnv()} org-info-content`}>
                <Index orgInfo={orgInfo} isLoading={props.isLoading}/>
            </Row>
            <Row className={userInfo?.isSuperAdmin
                ? "d-flex admin-view-main-content"
                : "d-flex user-main-content"}>
                <Col lg="2" md="3" xs="4" className="p-0 menu-content">
                    <Nav className="flex-column">
                        {orgInfo && menu
                            && menu.map((item: any) => (
                                <div key={item.id}
                                     className={item.path.includes(currentTab) ? "d-flex nav-item nav-item__selected" : "d-flex nav-item"}>
                                    <div className="nav-pre"></div>
                                    <Nav.Link
                                        as={Link}
                                        to={item.path[0]}
                                        className="nav-suf"
                                        disabled={item.path.includes(currentTab) ? true : false}
                                        onClick={() => setCurrentTab(item.path[0])}>
                                        {item.name}
                                    </Nav.Link>
                                </div>
                            ))}
                    </Nav>
                </Col>
                <Col lg="10" md="9" xs="8" className={userInfo?.isSuperAdmin
                    ? `settings-content scroll-content admin-view-scroll-content ${getClassEnv()}-content`
                    : `settings-content scroll-content user-scroll-content ${getClassEnv()}-content`}>
                    <Outlet/>
                </Col>
            </Row>
        </div>
    );
}